import { cn } from "../../../shared/landing-page/utils";
import "./button.scss";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({
  className,
  variant = "default",
  size = "md",
  children,
  ...props
}) => {
  const variantClass = {
    default: "Button-default",
    outline: "Button-outline",
    ghost: "Button-ghost",
  }[variant];

  const sizeClass = {
    sm: "Button-sm",
    md: "Button-md",
    lg: "Button-lg",
  }[size];

  return (
    <button className={cn("Button", variantClass, sizeClass, className)} {...props}>
      {children}
    </button>
  );
};
